document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const nav = document.querySelector('.site-nav');
if (menuButton && nav) {
  menuButton.addEventListener('click', () => {
    nav.style.display = nav.style.display === 'flex' ? '' : 'flex';
  });
}

const stickyAtc = document.querySelector('[data-sticky-atc]');
const productForm = document.querySelector('.product-form');
if (stickyAtc && productForm) {
  const observer = new IntersectionObserver(([entry]) => {
    stickyAtc.hidden = entry.isIntersecting;
  }, { threshold: 0.1 });
  observer.observe(productForm);
  stickyAtc.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
    productForm.requestSubmit();
  });
}
document.querySelectorAll('.product__media, .product__info').forEach(el => {
  el.addEventListener('wheel', function(e) {
    e.stopPropagation();
  }, { passive: true });
});
